import { _decorator, Sprite, SpriteFrame, CCString, CCBoolean } from 'cc';
import LocalizedSprite from '../LocalizedComponent/LocalizedSprite';
import MultiThemeComponent from './MultiThemeComponent';

const { ccclass, property, requireComponent, menu } = _decorator;

@ccclass('MultiThemeSprite')
@menu('MultiTheme/MultiThemeSprite')
@requireComponent(Sprite)
export default class MultiThemeSprite extends MultiThemeComponent<Sprite> {
    @property
    private readonly updateGrayscales: boolean = false;

    @property({
        type: [CCBoolean],
        visible(this: MultiThemeSprite) {
            return this.updateGrayscales;
        },
    })
    private readonly grayscales: boolean[] = [];

    @property
    private readonly updateSpriteFrames: boolean = false;

    @property({
        type: [SpriteFrame],
        formerlySerializedAs: '_spriteFrames',
        visible(this: MultiThemeSprite) {
            return this.updateSpriteFrames;
        },
    })
    private readonly spriteFrames: SpriteFrame[] = [];

    @property
    private readonly updateSpriteFrameKeys: boolean = false;

    @property({
        type: [CCString],
        visible(this: MultiThemeSprite) {
            return this.updateSpriteFrameKeys;
        },
    })
    private readonly spriteFrameKeys: string[] = [];

    private _localizedSprite: LocalizedSprite = null;

    private get localizedSprite() {
        if (!this._localizedSprite) {
            this._localizedSprite = this.target.getComponent(LocalizedSprite);
        }
        return this._localizedSprite;
    }

    public getMaxTheme(): number {
        if (this.updateGrayscales) {
            return this.grayscales.length;
        }
        if (this.updateSpriteFrames) {
            return this.spriteFrames.length;
        }
        if (this.updateSpriteFrameKeys) {
            return this.spriteFrameKeys.length;
        }
        return 0;
    }

    public replaceSpriteFrames(spriteFrames: SpriteFrame[]) {
        this.spriteFrames.length = 0;
        this.spriteFrames.push(...spriteFrames);
        this.onThemeChanged();
    }

    protected getTarget() {
        return this.getComponent(Sprite);
    }

    protected onThemeChanged() {
        if (this.updateGrayscales && this._theme < this.grayscales.length) {
            this.target.grayscale = this.grayscales[this._theme];
        }
        if (this.updateSpriteFrames && this._theme < this.spriteFrames.length) {
            this.target.spriteFrame = this.spriteFrames[this._theme];
        }
        if (this.updateSpriteFrameKeys && this._theme < this.spriteFrameKeys.length) {
            const key = this.spriteFrameKeys[this._theme];
            this.localizedSprite.key = this.spriteFrameKeys[this._theme];
            // clear spriteFrame if key is empty
            if (!key) {
                this.target.spriteFrame = null;
            }
        }
    }
}
